import React from 'react';
import {
  FaTwitter, FaFacebook, FaDiscord, FaInstagram, FaGlobe, FaYoutube,
} from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import {
  FooterContainer,
  FooterLogo,
  FooterWrapper,
  IconsWrapper,
  FooterIcon,
  FooterCopyright,
  FooterTextWrapper,
  FooterText,
} from './footerElements';
import Logo from '../../Images/General/Logo.png';

const index = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const toggleHome = async () => {
    if (location.pathname !== '/') {
      await navigate('/');
    }
    scroll.scrollToTop();
  };
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterLogo onClick={() => toggleHome()} alt="Logo" src={Logo} />
        <IconsWrapper>
          <FooterIcon href="http://d.ccnfts.io/" target="_blank" aria-label="Discord"><FaDiscord /></FooterIcon>
          <FooterIcon href="https://twitter.com/CarbonOffsetNFT" target="_blank" aria-label="Twitter"><FaTwitter /></FooterIcon>
          <FooterIcon href="https://www.instagram.com/accounts/login/?next=/carbonoffsetnft/" target="_blank" aria-label="Instagram"><FaInstagram /></FooterIcon>
          <FooterIcon href="https://www.facebook.com/Carbon-Collectible-NFTs-103176582194223/" target="_blank" aria-label="Facebook"><FaFacebook /></FooterIcon>
          <FooterIcon href="https://www.youtube.com/channel/UCg8JuQK30BryQPZ6oqcrGng" target="_blank" aria-label="Youtube"><FaYoutube /></FooterIcon>
          <FooterIcon href="mailto:info@ccNFTs.io" target="_blank" aria-label="Email"><MdEmail /></FooterIcon>
          <FooterIcon href="https://detailed.carboncollectiblenfts.com/" target="_blank" aria-label="Website"><FaGlobe /></FooterIcon>
        </IconsWrapper>
        <FooterTextWrapper>
          <FooterText href="https://carboncollectiblenfts.com/privacy_policy" target="_blank" rel="noreferrer">Privacy Policy</FooterText>
          <FooterText href="https://carboncollectiblenfts.com/terms_and_conditions" target="_blank" rel="noreferrer">Terms & Conditions</FooterText>
          <FooterText href="https://carboncollectiblenfts.com/cookies_policy" target="_blank" rel="noreferrer">Cookies Policy</FooterText>
        </FooterTextWrapper>
        <FooterCopyright>
          ©
          {' '}
          {new Date().getFullYear()}
          . All rights reserved
        </FooterCopyright>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default index;
